export const WIDGET_THEME = {
  primaryColor: '#1976d2',
  primaryColorLight: '#42a5f5',
  primaryColorDark: '#0d47a1',
  backgroundColor: '#f5f7fa',
  textColor: '#222222',
  textColorInverted: '#ffffff',
  buttonSize: '52px',
  cardBackground: '#ffffff',
  borderColor: '#d1d5db',
  focusRingColor: '#1976d2',
  hoverColor: '#42a5f5',
  activeColor: '#0d47a1',
  successColor: '#2e7d32',
  errorColor: '#c62828',
  warningColor: '#f57c00',
  headerHeight: '54px',
  borderRadius: '8px',
  buttonBorderRadius: '0.4rem',
  menuPosition: null,
  zIndex: 100000,
  focusBorderWidth: '3px',
  focusOutlineOffset: '2px',

  // ── Toggle button (floating launcher) ──────────────────────────────────────
  // Defaults to primaryColor when not set (see applyThemeVariables fallback logic)
  toggleButtonBg: '',
  toggleButtonRingColor: '',
  toggleButtonIconColor: '#ffffff',
  toggleButtonBorderRadius: '',
  toggleButtonPaddingX: '',
  toggleButtonShadow: '',
  toggleButtonShadowHover: '',
  toggleButtonLabel: '',
  toggleButtonShortcut: '',
  toggleLabelFontSize: '1rem',
  toggleLabelFontWeight: '700',
  toggleShortcutFontSize: '0.7rem',
  toggleShortcutFontWeight: '600',

  // ── Menu chrome ────────────────────────────────────────────────────────────
  menuHeaderBg: '',
  menuHeaderColor: '#ffffff',

  // ── Feature buttons (inside the menu) ──────────────────────────────────────
  featureIconColor: '#222222',
  featureIconActiveColor: '',
  featureButtonActiveBg: '',
  featureButtonActiveBorderColor: '',
  featureButtonHoverBg: '#f3f4f6',

  // ── Section headings ───────────────────────────────────────────────────────
  sectionTitleColor: '#6b7280',

  // ── Panel sizing & layout ──────────────────────────────────────────────────
  menuMaxWidth: '',
  menuFontSize: '',
  menuScale: '',
  menuBorderRadius: '',
  menuContentPadding: '',
  menuSectionGap: '',
  menuCategoryGap: '',
  sectionTitleFontSize: '',
  featureButtonGap: '',
  featureButtonPadding: '',
  featureButtonFontSize: '',
  featureButtonLabelSize: '',
  featureIconSize: '',
  headerIconSize: '',
};
